module.exports = __webpack_public_path__ + "img/result.e382cc5e.svg";